var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/cart_tray_icon.1a3dd6de.png","uri@2x": __webpack_public_path__ + "static/media/cart_tray_icon.bd169b8e.png","uri@3x": __webpack_public_path__ + "static/media/cart_tray_icon.7232da0e.png",
    width: 14,
    height: 16
});